module.exports = __webpack_public_path__ + "static/media/asiviewer.52a3d550.png";